import React from 'react';

export const Shield: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      d="M14.962 2.5A9.652 9.652 0 018 0a9.651 9.651 0 01-6.961 2.5C1.039 6.979.06 13.395 8 16c7.941-2.606 6.962-9.021 6.962-13.5zm-7.535 7.881l-2.319-2.2L6.143 7.2l1.284 1.215 2.435-2.3 1.038.983z"
      fill="currentColor"
    />
  </svg>
);
